import { chirpGateways, createChirpFetch, loadBalancers } from 'chirp-fetch';
import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { useEffect, useState } from 'react';
import { createRpcClientV2 } from 'rpc-client-utils';
import { streamAiResponseRpc as streamAiResponsePublicRpc } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc';
import { streamAiResponseRpc } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc';
import { useAppContext } from '../../context/AppContext';
const STREAM_TIMEOUT_MS = 30000;
const appChirpFetch = createChirpFetch({
  loadBalancer: loadBalancers.APP,
  gateway: chirpGateways.APP
});
const publicChirpFetch = createChirpFetch({
  loadBalancer: loadBalancers.APP,
  gateway: chirpGateways.EXTERNAL
});
export const appStreamClient = createRpcClientV2({
  hubHttpClient: http,
  fetchClient: appChirpFetch
});
export const publicStreamClient = createRpcClientV2({
  hubHttpClient: noAuthHttp,
  fetchClient: publicChirpFetch
});
export function useStreamAiSummary({
  onFinish,
  requestId,
  skip
}) {
  const [streamingAnswer, setStreamingAnswer] = useState('');
  const appContext = useAppContext();
  useEffect(() => {
    if (skip || !requestId) return;

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setStreamingAnswer('');
    const client = appContext === 'app' ? appStreamClient : publicStreamClient;
    const rpc = appContext === 'app' ? streamAiResponseRpc : streamAiResponsePublicRpc;
    const streamHandler = client.stream(rpc, {
      request: {
        requestId
      },
      timeout: STREAM_TIMEOUT_MS
    });
    void streamHandler.onMessage(message => {
      if (message.type === 'rpcError' || message.data.status === 'FAILURE') {
        onFinish('FAILURE');
        return;
      }
      const {
        delta,
        completeAnswer
      } = message.data;
      if (completeAnswer) {
        setStreamingAnswer(completeAnswer);
        onFinish('SUCCESS');
        return;
      }
      if (delta) {
        setStreamingAnswer(prev => prev + delta);
      }
    }).catch(() => {
      onFinish('FAILURE');
    });
    return () => {
      streamHandler.abort();
    };
  }, [requestId, skip, appContext, onFinish]);
  return streamingAnswer;
}